<template>
<div class="content" @click="goNextStep()">
  <i class="fas fa-chevron-right fa-3x" style="color: white"></i>
</div>
</template>

<script>
export default {
  name: 'next-button',
  methods: {
    goNextStep: function () {
      // On ne peut aller à l'étape suivante que si on est connecté et que le fichier de configuration est bien présent.
      if (this.$store.getters['user/isAuthenticated'] && this.$store.getters['config/isConfigOk']) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.$store.state.form.dataToSave);
      } else if (!this.$store.getters['config/isConfigOk']) {
        this.$store.dispatch('config/CONFIG_TOGGLECONFIGMODE');
      }
    }
  }
};
</script>

<style scoped>
.content {
  height: 100%;
  background-color: rgba(63, 63, 63, 0.5);
  cursor: pointer;
}.content > i {
   position:relative;
   top: calc(50% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/components/NextButton.vue